/* @flow */
/* eslint no-unused-vars: 0 */

import React from "react"

class ProductsLoading extends React.PureComponent {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <div className={"products--search-container" + (this.props.loading === false ? " hidden" : "") }>
        <div className="products--search-loader">
          <div className="loader" />
        </div>
      </div>
    );
  }
}

export default ProductsLoading;
